



import IMapProperty from './private/IMapProperty';


const MAPPINGS: Array<IMapProperty> = [
{
    'localName' : 'id',
    'externalName' : 'id',
    'defaultValue' : 0,
},
{
    'localName' : 'parentId',
    'externalName' : 'parentId',
    'defaultValue' : 0,
},
{
    'localName' : 'isDefault',
    'externalName' : 'isDefault',
    'defaultValue' : false,
},
{
    'localName' : 'siteId',
    'externalName' : 'siteId',
    'defaultValue' : 0,
},
{
    'localName' : 'name',
    'externalName' : 'name',
    'defaultValue' : '',
},
{
    'localName' : 'description',
    'externalName' : 'description',
    'defaultValue' : '',
},
{
    'localName' : 'foregroundImageMediumId',
    'externalName' : 'foregroundImageMediumId',
    'defaultValue' : '',
},
{
    'localName' : 'backgroundImageMediumId',
    'externalName' : 'backgroundImageMediumId',
    'defaultValue' : '',
},
{
    'localName' : 'backgroundColor',
    'externalName' : 'backgroundColor',
    'defaultValue' : '',
},
{
    'localName' : 'menuImageMediumId',
    'externalName' : 'menuImageMediumId',
    'defaultValue' : '',
},
{
    'localName' : 'backgroundModeId',
    'externalName' : 'backgroundModeId',
    'defaultValue' : 0,
},
{
    'localName' : 'menuColor',
    'externalName' : 'menuColor',
    'defaultValue' : '',
},
{
    'localName' : 'primaryFontFamilyId',
    'externalName' : 'primaryFontFamilyId',
    'defaultValue' : 0,
},
{
    'localName' : 'primaryFontStyleId',
    'externalName' : 'primaryFontStyleId',
    'defaultValue' : 0,
},
{
    'localName' : 'primaryFontSize',
    'externalName' : 'primaryFontSize',
    'defaultValue' : 0,
},
{
    'localName' : 'primaryFontSizeUnitId',
    'externalName' : 'primaryFontSizeUnitId',
    'defaultValue' : 0,
},
{
    'localName' : 'primaryFontColor',
    'externalName' : 'primaryFontColor',
    'defaultValue' : '',
},
{
    'localName' : 'primaryFontAlignmentId',
    'externalName' : 'primaryFontAlignmentId',
    'defaultValue' : 0,
},
{
    'localName' : 'secondaryFontFamilyId',
    'externalName' : 'secondaryFontFamilyId',
    'defaultValue' : 0,
},
{
    'localName' : 'secondaryFontStyleId',
    'externalName' : 'secondaryFontStyleId',
    'defaultValue' : 0,
},
{
    'localName' : 'secondaryFontSize',
    'externalName' : 'secondaryFontSize',
    'defaultValue' : 0,
},
{
    'localName' : 'secondaryFontSizeUnitId',
    'externalName' : 'secondaryFontSizeUnitId',
    'defaultValue' : 0,
},
{
    'localName' : 'secondaryFontColor',
    'externalName' : 'secondaryFontColor',
    'defaultValue' : '',
},
{
    'localName' : 'secondaryFontAlignmentId',
    'externalName' : 'secondaryFontAlignmentId',
    'defaultValue' : 0,
},
{
    'localName' : 'tertiaryFontFamilyId',
    'externalName' : 'tertiaryFontFamilyId',
    'defaultValue' : 0,
},
{
    'localName' : 'tertiaryFontStyleId',
    'externalName' : 'tertiaryFontStyleId',
    'defaultValue' : 0,
},
{
    'localName' : 'tertiaryFontSize',
    'externalName' : 'tertiaryFontSize',
    'defaultValue' : 0,
},
{
    'localName' : 'tertiaryFontSizeUnitId',
    'externalName' : 'tertiaryFontSizeUnitId',
    'defaultValue' : 0,
},
{
    'localName' : 'tertiaryFontColor',
    'externalName' : 'tertiaryFontColor',
    'defaultValue' : '',
},
{
    'localName' : 'tertiaryFontAlignmentId',
    'externalName' : 'tertiaryFontAlignmentId',
    'defaultValue' : 0,
},
{
    'localName' : 'foregroundImageFileName',
    'externalName' : 'foregroundImageFileName',
    'defaultValue' : '',
},
{
    'localName' : 'removeForegroundImage',
    'externalName' : 'removeForegroundImage',
    'defaultValue' : false,
},
{
    'localName' : 'menuImageFileName',
    'externalName' : 'menuImageFileName',
    'defaultValue' : '',
},
{
    'localName' : 'removeMenuImage',
    'externalName' : 'removeMenuImage',
    'defaultValue' : false,
},
{
    'localName' : 'backgroundImageFileName',
    'externalName' : 'backgroundImageFileName',
    'defaultValue' : '',
},
{
    'localName' : 'removeBackgroundImage',
    'externalName' : 'removeBackgroundImage',
    'defaultValue' : false,
},
{
    'localName' : 'hasChildren',
    'externalName' : 'hasChildren',
    'defaultValue' : false,
},
];

export default MAPPINGS;

